module.exports = __webpack_public_path__ + "media/lorenzo.278acde1.mp3";